import React from 'react';
import ServiceTemplate from './ServiceTemplate';

const Immobilien = () => {
  const pageData = {
    title: 'IMMOBILIEN',
    subtitle: 'Professionelle Immobilienverwaltung',
    description: 'Marali Immobilien AG – Ihr kompetenter Partner für Immobilienverwaltung, Vermietung und Verkauf in Cazis und Graubünden. Professionell, zuverlässig, transparent.',
    heroImage: 'https://images.unsplash.com/photo-1734169065204-127b2b724c7a?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Njl8MHwxfHNlYXJjaHwxfHxsdXh1cnklMjByZWFsJTIwZXN0YXRlJTIwbW9kZXJuJTIwaG91c2UlMjBleHRlcmlvciUyMHN3aXR6ZXJsYW5kfGVufDB8fHx8MTc3NzYyOTk0NHww&ixlib=rb-4.1.0&q=85',
    features: [
      { title: 'Immobilienverwaltung', description: 'Professionelle Verwaltung von Wohn- und Gewerbeimmobilien.' },
      { title: 'Vermietung', description: 'Erfolgreiche Vermarktung Ihrer Immobilien an qualifizierte Mieter.' },
      { title: 'Verkauf', description: 'Kompetente Beratung beim Immobilienverkauf zu Top-Konditionen.' },
      { title: 'Bewertung', description: 'Faire und realistische Immobilienbewertungen durch Experten.' },
      { title: 'Beratung', description: 'Umfassende Beratung zu allen Immobilienthemen.' },
      { title: 'Objektbetreuung', description: 'Regelmäßige Kontrolle und Wartung Ihrer Immobilien.' }
    ],
    benefits: [
      'Langjährige Erfahrung in der Immobilienbranche',
      'Lokale Marktkenntnis in Graubünden',
      'Persönliche und transparente Betreuung',
      'Umfassendes Dienstleistungsangebot',
      'Professionelles Netzwerk',
      'Faire Konditionen'
    ],
    process: [
      { title: 'Erstgespräch', description: 'Kostenlose Beratung zu Ihren Immobilienwünschen.' },
      { title: 'Analyse', description: 'Detaillierte Bewertung und Marktanalyse.' },
      { title: 'Strategie', description: 'Entwicklung der optimalen Verwaltungs- oder Verkaufsstrategie.' },
      { title: 'Umsetzung', description: 'Professionelle Durchführung aller vereinbarten Leistungen.' }
    ],
    gallery: [
      'https://images.unsplash.com/photo-1666467126593-17859fd13942?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Njl8MHwxfHNlYXJjaHwyfHxsdXh1cnklMjByZWFsJTIwZXN0YXRlJTIwbW9kZXJuJTIwaG91c2UlMjBleHRlcmlvciUyMHN3aXR6ZXJsYW5kfGVufDB8fHx8MTc3NzYyOTk0NHww&ixlib=rb-4.1.0&q=85',
      'https://images.unsplash.com/photo-1754157395678-2790d636f428?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Njl8MHwxfHNlYXJjaHwzfHxsdXh1cnklMjByZWFsJTIwZXN0YXRlJTIwbW9kZXJuJTIwaG91c2UlMjBleHRlcmlvciUyMHN3aXR6ZXJsYW5kfGVufDB8fHx8MTc3NzYyOTk0NHww&ixlib=rb-4.1.0&q=85'
    ],
    metaKeywords: 'Immobilien Cazis, Immobilienverwaltung Graubünden, Wohnung mieten Cazis, Haus verkaufen Graubünden'
  };

  return <ServiceTemplate {...pageData} />;
};

export default Immobilien;
